module.exports = __webpack_public_path__ + "img/Inflammation-OVCA_10X_WTA.0a3c1007.png";